import { topicItems } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center mb-3">热门话题</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">社区热聊话题标签，看看大家都在讨论什么</p>
        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((item) => (
            <a
              key={item.id}
              href="#topics"
              className="group flex items-center gap-2 px-4 py-2.5 bg-background-100 hover:bg-primary-50 border border-background-200/70 hover:border-primary-300 rounded-full transition-all duration-200 cursor-pointer"
            >
              <span className="text-sm text-foreground-700 group-hover:text-primary-600 whitespace-nowrap font-medium">
                # {item.name}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{item.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}